__turbopack_context__.v({
  "canvas": "iZ-r5G_canvas",
  "cssRing": "iZ-r5G_cssRing",
  "cssRingAnimated": "iZ-r5G_cssRingAnimated",
  "rippleOut": "iZ-r5G_rippleOut",
  "root": "iZ-r5G_root",
  "wrap": "iZ-r5G_wrap",
});
